import { FC } from 'react'
import { BooksProduct } from 'src/api/booksProducts'
import { RefundTab } from './ProductDetailContent.style'

const ProductDetailTerms: FC<{ productType: BooksProduct['productType'] }> = ({ productType }) => {
	return productType === 'aladinbook' ? (
		<RefundTab name="bookShipRefund">
			<h3>배송/반품/교환 정보</h3>
			<div className={'wrapper'}>
				<p className={'title'}>배송 정보</p>
				<div className={'content'}>
					<ol>
						<li>
							도서 배송 상품은 2,500원의 배송 비용이 발생합니다. (도서산간지역 포함,
							해외배송의 경우 별도 안내)
						</li>
						<li>도서 배송 비용은 3만원 이상 구매시 무료입니다.</li>
						<li>
							서책 상품의 경우 결제 확인 후 상품 수령까지 영업일 기준{' '}
							<b>2~4일 정도</b> 소요됩니다.
						</li>
					</ol>
				</div>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>반품/교환 방법</p>
				<p className={'content'}>
					&quot; 홈페이지 우측 하단의 상담 버튼 &gt; 대화 &gt; 새 문의하기 &gt; 환불
					문의&quot; <br />
					환불 가능 여부 확인 후, 영업일 기준 1~3일 내에 환불 신청이 완료됩니다.
					<br />
					상품 회수 및 환불 처리 일정은 택배사 상황에 따라 변동될 수 있습니다.
				</p>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>반품/교환 가능 기간</p>
				<div className={'content'}>
					<ul>
						<li>변심반품: 수령 후 20일</li>
						<li>파본 등 상품결함 시: 문제점 발견 후 30일</li>
					</ul>
				</div>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>반품/교환 비용</p>
				<div className={'content'}>
					<ul>
						<li>
							단순 변심 혹은 구매 착오의 경우 반송료는 고객이 부담합니다. 단, 아래의
							주문/취소 조건인 경우 취소 수수료가 면제됩니다.
							<br />- 당일 00시 ~ 24시 주문을 당일 24시 이전에 취소하는 경우
						</li>
					</ul>
				</div>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>반품/교환 불가 사유</p>
				<div className={'content'}>
					<ul>
						<li>소비자에게 책임이 있는 사유로 인해 상품이 손실 또는 훼손된 경우</li>
						<li>
							소비자의 상품 사용, 포장 개봉 등에 의해 상품의 가치가 현저히 감소한 경우{' '}
							<br />
							예) 랩핑이 제거된 수험서/문제집류
						</li>
						<li>
							상품 구매 시 함께 제공 받은 서비스 혹은 상품을 사용하거나 열람한 경우
						</li>
						<li>반품/교환 가능 기간이 경과한 경우</li>
					</ul>
				</div>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>소비자 피해보상/환불지연에 따른 배상</p>
				<div className={'content'}>
					<ul>
						<li>
							상품의 불량에 의한 반품, 교환, 환불, 품질보증 및 피해보상 등에 관한
							사항은 소비자분쟁해결기준 (공정거래위원회 고시) 에 준하여 처리됩니다.
						</li>
						<li>
							대금 환불 및 환불 지연에 따른 배상금 지급 조건, 절차 등은 전자상거래
							등에서의 소비자 보호에 관한 법률에 따라 처리함
						</li>
					</ul>
				</div>
			</div>
		</RefundTab>
	) : productType === 'ebook' ? (
		<RefundTab name="refund">
			<h3>환불/교환 정보</h3>
			<div className={'wrapper'}>
				<p className={'title'}>환불 방법</p>
				<p className={'content'}>
					&quot;홈페이지 우측 하단의 상담 버튼 &gt; 대화 &gt; 새 문의하기 &gt; 환불
					문의&quot; 를 통해 환불을 신청할 수 있습니다. 환불 가능 여부 확인 후 영업일 기준
					1~3일 내에 환불 신청이 완료됩니다.
				</p>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>환불 가능 기간</p>
				<p className={'content'}>
					상품을 이용하지 않은 경우 (이용 조건 및 환불 가능 조건은 하기 환불 조건 참고),
					결제일로부터 7일 이내에 환불을 요청할 수 있습니다.
				</p>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>환불/교환 조건</p>
				<div className={'content'}>
					<ul>
						<li>
							결제한 eBook 을 굿노트6 앱에서 열람한 이력이 있을 경우 환불 처리가
							불가능합니다.
						</li>
						<li>
							굿노트6 앱에서 교재를 실수로 삭제했거나 eBook 상품을 잘못 구매한 경우
							쏠북 고객센터에서 “쏠북 매니저 연결하기” 메뉴를 선택해주세요.
						</li>
					</ul>
				</div>
			</div>
		</RefundTab>
	) : (
		<RefundTab producttype={productType} name="refund">
			<h3>환불/교환 정보</h3>
			<div className={'wrapper'}>
				<p className={'title'}>환불 방법</p>
				<p className={'content'}>
					홈페이지 우측 하단의 상담 버튼을 클릭, 새 상담하기 &gt; 환불 문의 버튼을 눌러
					신청할 수 있습니다.
					<br />
					환불 가능 여부 확인 후, 영업일 기준 1~3일 내에 순차적으로 환불이 진행됩니다.
				</p>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>환불 가능 기간</p>
				<p className={'content'}>
					상품을 이용하지 않은 경우(이용 조건은 하기 환불/교환 조건을 참고), 결제일로부터
					14일 이내에 환불을 요청할 수 있습니다.
				</p>
			</div>
			<div className={'wrapper'}>
				<p className={'title'}>환불/교환 조건</p>
				<div className={'content'}>
					아래의 경우 상품을 이용한 것으로 간주하며, 환불할 수 없습니다.
					<ul>
						<li>구매한 상품을 열람한 경우</li>
						<li>구매한 상품을 쏠북 엑스퍼트로 불러온 경우</li>
						<li>
							(저작권 해결을 위해 구매한 라이선스 상품에 한함) 구매한 라이선스를
							활용한 상품을 쏠북 마켓에 판매 등록하거나 해당 상품의 판매 수익이 발생한
							경우
						</li>
					</ul>
					아래의 경우 환불이 가능한 지 고객센터에 확인 요청할 수 있습니다.
					<ul>
						<li>구매한 상품에 오류가 있는 경우</li>
					</ul>
				</div>
			</div>
		</RefundTab>
	)
}

export default ProductDetailTerms
